import { delay, nextFrame } from "../../helpers"

class ToastNotificationElement extends HTMLElement {
  async connectedCallback() {
    if (this.started) return
    this.started = true

    await nextFrame()
    this.setup()

    await delay(100)
    this.show()

    await delay(this.duration)
    this.hide()

    await delay(500)
    this.remove()
  }

  setup() {
    document.body.append(this)
    this.setAttribute("role", "alert")
    this.popover = "manual"
  }

  show() {
    this.showPopover()
    this.toggleAttribute("visible", true)
  }

  hide() {
    this.hidePopover()
    this.toggleAttribute("visible", false)
  }

  get duration() {
    return Number(this.getAttribute("duration") || 2000)
  }

  set duration(duration) {
    this.setAttribute("duration", duration)
  }
}

customElements.define("toast-notification", ToastNotificationElement)
